var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { inject, observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router';
import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { mergeQueryString, updateSearch } from 'bernie-core';
import { ActivityQueryParamsProvider, ActivitySortAndFilters, SortAndFiltersViewType, useActivityURLParamsToQueryInputs } from '@shared-ui/retail-sort-and-filter-activity';
import { useStores } from '../../../utils/hooks';
import { buildUrlQueryString, getUpdatedFilterQueryObject } from './universal-sort-filter-utils';
export var UniversalSortFilter = inject('context', 'experiment', 'page')(observer(function (_a) {
  var _b, _c, _d, _e;
  var view = _a.view,
    _f = _a.className,
    className = _f === void 0 ? '' : _f;
  var _g = __read(React.useState(''), 2),
    urlQueryString = _g[0],
    setUrlQueryString = _g[1];
  var history = useHistory();
  var location = useLocation();
  var isFiltersDialog = [SortAndFiltersViewType.SORT_AND_FILTERS, SortAndFiltersViewType.FILTER_DIALOG, SortAndFiltersViewType.FILTER_BAR].includes(view);
  var _h = useStores(),
    activitySearchStore = _h.activitySearchStore,
    searchCriteriaStore = _h.searchCriteriaStore;
  var isSearchResultsLoading = activitySearchStore === null || activitySearchStore === void 0 ? void 0 : activitySearchStore.loadingActivities;
  var updateSearchWithQuery = function (query) {
    var queryCombiner = function (_prevQuery, newQuery) {
      return newQuery;
    };
    updateSearch({
      history: history,
      location: location,
      newParams: query,
      replace: false,
      queryCombiner: queryCombiner
    });
  };
  var getNewQueryString = function (field, event) {
    var _a;
    var name = field.name,
      value = field.value;
    var eventTargetType = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.type;
    var existingUrlQueryString = isFiltersDialog && urlQueryString !== '' ? urlQueryString : location.search;
    return buildUrlQueryString({
      name: name,
      value: value,
      existingUrlQueryString: existingUrlQueryString,
      eventTargetType: eventTargetType
    });
  };
  var onFieldChange = function (field, event) {
    var newQueryString = getNewQueryString(field, event);
    // this component renders several different types of filter views - when the child filter view is a dialog
    // we simply capture filter field changes as local state in the form of a new query string
    // if it's not a dialog, we go ahead and update the page's query string with the new one we generated
    if (isFiltersDialog) {
      setUrlQueryString(newQueryString);
    } else {
      updateSearchWithQuery(newQueryString);
      window.scrollTo(0, 0);
    }
  };
  // helper function that updates search with query
  var searchNewQuery = function (currentQueryString) {
    var newQueryString = mergeQueryString(currentQueryString, {}, function (key) {
      return !key.startsWith('pwaDialog');
    });
    setTimeout(function () {
      updateSearchWithQuery(newQueryString);
    }, 50);
    setUrlQueryString('');
  };
  var onSubmitFilters = React.useCallback(function () {
    var currentQueryString = urlQueryString === '' ? history.location.search : urlQueryString;
    searchNewQuery(currentQueryString);
  }, [urlQueryString]);
  // this will fire a query when hitting Done (just updates the url)
  var onDone = function (field, event) {
    onFieldChange(field, event);
  };
  // this will fire a query when hitting Enter key (submits the new url)
  var onKeyDown = function (field, event) {
    var newQueryString = getNewQueryString(field, event);
    searchNewQuery(newQueryString);
  };
  var inputs = useActivityURLParamsToQueryInputs();
  var getSort = function () {
    var _a, _b;
    if (inputs === null || inputs === void 0 ? void 0 : inputs.sort) {
      return inputs.sort;
    }
    if (!((_b = (_a = searchCriteriaStore.searchVariables) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.selections)) {
      return '';
    }
    var sortFilter = searchCriteriaStore.searchVariables.filters.selections.find(function (filter) {
      return filter.id === 'sort';
    });
    return sortFilter === null || sortFilter === void 0 ? void 0 : sortFilter.value;
  };
  var categories = {
    destination: (_b = inputs === null || inputs === void 0 ? void 0 : inputs.destination) !== null && _b !== void 0 ? _b : {},
    dateRange: (_e = (_c = inputs === null || inputs === void 0 ? void 0 : inputs.dateRange) !== null && _c !== void 0 ? _c : (_d = searchCriteriaStore.searchVariables) === null || _d === void 0 ? void 0 : _d.dateRange) !== null && _e !== void 0 ? _e : {},
    filters: inputs && inputs.filters && Object.keys(inputs.filters).length ? inputs.filters : getUpdatedFilterQueryObject(new URLSearchParams(location.search)),
    sort: getSort()
  };
  return React.createElement("div", {
    className: className
  }, React.createElement(ActivitySortAndFilters, {
    onFieldChange: onFieldChange,
    onSubmit: onSubmitFilters,
    view: view,
    inputs: categories,
    loading: isSearchResultsLoading,
    onDone: onDone,
    onKeyDown: onKeyDown
  }));
}));
export var UniversalSortFilterWrapper = function (_a) {
  var view = _a.view,
    className = _a.className;
  var location = useLocation();
  return React.createElement(ErrorBoundary, {
    label: "lx.search.universal-sort-filter"
  }, React.createElement(ActivityQueryParamsProvider, {
    urlSearchParams: new URLSearchParams(location.search)
  }, React.createElement(UniversalSortFilter, {
    view: view,
    className: className
  })));
};